<template>
  <div class="ipro w clearfix">
    <div class="headx">
      <h2>
        <em>
          <b>热门</b>视频
        </em>
        <span></span>
      </h2>
      <a href="/course/course_in" class="mo">MORE+</a>
    </div>
    <div class="tod">
      <ul>
        <li v-for="(item, index) in nowData" :key="index">
          <a :href="'/course/CourseDetails?id=' + item.id" :title="item.name">
            <img :src="http + item.attachfile" :alt="item.name" :title="item.name" />
          </a>
          <div class="wd">
            <b>
              <a :href="'/course/CourseDetails?id=' + item.id" :title="item.name">{{item.name}}</a>
            </b>
            <div class="description">{{ item.ms }}</div>
            <a :href="'/course/CourseDetails?id=' + item.id" class="detail">查看详情&gt;</a>
          </div>
        </li>
        
      </ul>
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  data() {
    return {
      isDesktop: window.innerWidth > 428,
      http: process.env.VUE_APP_BASE_API,
      nowData:[],
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    this.getHot();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      // 根据窗口宽度更新 isDesktop 状态
      },
      async getHot() {
       const res = await method.index();
       if (res.code == 1) {
        this.nowData = res.data.kc;
       }
      // // console.log(this.nowData);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/pc/index_Hot.scss";
@import "@/assets/css/move/index_Hot.scss"
</style>